import { SafeAreaView, ScrollView, SxProp, View } from 'dripsy';
import React from 'react';

import { PageContainer } from '@/features/earn/components/page/PageContainer';
import { PageItem } from '@/features/earn/components/page/PageItem';
import { DevToolsPageHeader } from '../components/DevToolsPageHeader';
import { DevToolsStackRoutes, DevToolsStackScreenProps } from '../types';
import { H1, H2, H3, H4, H5, H6, TextBody, TextCaption, TextTitle } from '@/design-system/components/typography';
export const DevToolsTypography: React.FC<DevToolsStackScreenProps<DevToolsStackRoutes.Typography>> = ({}) => {
  return (
    <SafeAreaView sx={styles.container}>
      <ScrollView showsVerticalScrollIndicator={false}>
        <PageContainer sx={{ paddingX: '$10', paddingY: '$10', backgroundColor: 'transparent' }}>
          <DevToolsPageHeader currentPage={DevToolsStackRoutes.Typography} />
          <View sx={{ gap: '$5' }}>
            <PageItem sx={{ ...styles.pageItem, gap: '$5' }}>
              <PageItem sx={{ ...styles.pageItem, gap: '$5' }}>
                <TextTitle bold>Usage</TextTitle>
                <TextBody>{'<H6 bold label secondary>Text</H6>'}</TextBody>
              </PageItem>
              <PageItem sx={{ ...styles.pageItem, gap: '$5', zIndex: 1000 }}>
                <H6 bold label>
                  H1
                </H6>
                {/* Button Size */}
                <H1 label>This is H1 regular.</H1>
                <H1 label semiBold>
                  This is H1 semiBold.
                </H1>
                <H1 label bold>
                  This is H1 bold.
                </H1>
              </PageItem>
              <PageItem sx={{ ...styles.pageItem, gap: '$5', zIndex: 1000 }}>
                <H6 bold label>
                  H2
                </H6>
                {/* Button Size */}
                <H2 label>This is H2 regular.</H2>
                <H2 label semiBold>
                  This is H2 semiBold.
                </H2>
                <H2 label bold>
                  This is H2 bold.
                </H2>
              </PageItem>
              <PageItem sx={{ ...styles.pageItem, gap: '$5', zIndex: 1000 }}>
                <H6 bold label>
                  H3
                </H6>
                {/* Button Size */}
                <H3 label>This is H3 regular.</H3>
                <H3 label semiBold>
                  This is H3 semiBold.
                </H3>
                <H3 label bold>
                  This is H3 bold.
                </H3>
              </PageItem>
              <PageItem sx={{ ...styles.pageItem, gap: '$5', zIndex: 1000 }}>
                <H6 bold label>
                  H4
                </H6>
                {/* Button Size */}
                <H4 label>This is H4 regular.</H4>
                <H4 label semiBold>
                  This is H4 semiBold.
                </H4>
                <H4 label bold>
                  This is H4 bold.
                </H4>
              </PageItem>
              <PageItem sx={{ ...styles.pageItem, gap: '$5', zIndex: 1000 }}>
                <H6 bold label>
                  H5
                </H6>
                {/* Button Size */}
                <H5 label>This is H5 regular.</H5>
                <H5 label semiBold>
                  This is H5 semiBold.
                </H5>
                <H5 label bold>
                  This is H5 bold.
                </H5>
              </PageItem>
              <PageItem sx={{ ...styles.pageItem, gap: '$5', zIndex: 1000 }}>
                <H6 bold label>
                  H6
                </H6>
                {/* Button Size */}
                <H6 label>This is H6 regular.</H6>
                <H6 label semiBold>
                  This is H6 semiBold.
                </H6>
                <H6 label bold>
                  This is H6 bold.
                </H6>
              </PageItem>
              <PageItem sx={{ ...styles.pageItem, gap: '$5', zIndex: 1000 }}>
                <H6 bold label>
                  TextTitle
                </H6>
                {/* Button Size */}
                <TextTitle label>This is TextTitle regular.</TextTitle>
                <TextTitle label semiBold>
                  This is TextTitle semiBold.
                </TextTitle>
                <TextTitle label bold>
                  This is TextTitle bold.
                </TextTitle>
              </PageItem>
              <PageItem sx={{ ...styles.pageItem, gap: '$5', zIndex: 1000 }}>
                <H6 bold label>
                  TextBody
                </H6>
                {/* Button Size */}
                <TextBody label>This is TextBody regular.</TextBody>
                <TextBody label semiBold>
                  This is TextBody semiBold.
                </TextBody>
                <TextBody label bold>
                  This is TextBody bold.
                </TextBody>
              </PageItem>
              <PageItem sx={{ ...styles.pageItem, gap: '$5', zIndex: 1000 }}>
                <H6 bold label>
                  TextCaption
                </H6>
                {/* Button Size */}
                <TextCaption label>This is TextCaption regular.</TextCaption>
                <TextCaption label semiBold>
                  This is TextCaption semiBold.
                </TextCaption>
                <TextCaption label bold>
                  This is TextCaption bold.
                </TextCaption>
              </PageItem>
            </PageItem>
          </View>
        </PageContainer>
      </ScrollView>
    </SafeAreaView>
  );
};

enum StyleName {
  container = 'container',
  pageItem = 'pageItem'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    height: '100%',
    width: '100%',
    backgroundColor: '$backgroundPrimary',
    zIndex: -100
  },
  pageItem: {
    width: '100%',
    padding: '$7',
    borderRadius: 10,
    gap: '$2',
    zIndex: -100
  }
};
